interface LeaderboardItemProps {
  rank: number;
  name: string;
  avatar: string;
  currentProgress: number;
  totalProgress: number;
  isCurrentUser?: boolean;
  onClick?: () => void;
  /** Optional custom progress display string (for marathon: "12.5 km" or "3:42:15 ✓") */
  customProgressDisplay?: string;
}

export function LeaderboardItem({
  rank,
  name,
  avatar,
  currentProgress,
  totalProgress,
  isCurrentUser = false,
  onClick,
  customProgressDisplay,
}: LeaderboardItemProps) {
  const progressPercentage = (currentProgress / totalProgress) * 100;
  const progressDisplay = customProgressDisplay ?? `${currentProgress}/${totalProgress}`;

  return (
    <div
      onClick={onClick}
      className={`flex items-center gap-4 rounded-lg p-3 ${onClick ? 'cursor-pointer active:scale-[0.98] transition-transform' : ''} ${
      isCurrentUser
        ? 'bg-[#FF007F]/20 border-2 border-[#FF007F]/50'
        : 'bg-black/5 dark:bg-white/5'
    }`}>
      <span className={`text-lg w-6 text-center ${
        isCurrentUser ? 'font-bold text-content-light dark:text-content-dark' : 'font-medium text-content-light/70 dark:text-content-dark/70'
      }`}>
        {rank}
      </span>
      <img
        className="size-12 rounded-full object-cover"
        src={avatar}
        alt={`${name} profile`}
      />
      <div className="flex-1">
        <p className={`text-content-light dark:text-content-dark ${isCurrentUser ? 'font-bold text-lg' : 'font-medium'}`}>
          {name}
        </p>
        <div className="w-full bg-black/20 dark:bg-white/20 rounded-full h-1.5 mt-1">
          <div
            className={`h-1.5 rounded-full ${isCurrentUser ? 'bg-content-light dark:bg-content-dark' : 'bg-primary'}`}
            style={{ width: `${progressPercentage}%` }}
          />
        </div>
      </div>
      <p className={`font-bold text-lg ${isCurrentUser ? 'text-content-light dark:text-content-dark' : 'text-content-light/70 dark:text-content-dark/70'}`}>
        {progressDisplay}
      </p>
    </div>
  );
}
